import React from 'react'
import { Typography, type TypographyProps, styled } from '@mui/material'
import { GenericLoader } from '../GenericLoader'
import type { LoadingProps } from '../LoadingProps'

const BlockTypography = styled(Typography)`
    display: block;
`
interface Props extends LoadingProps, Omit<TypographyProps, 'width'> {}

export const LoaderBody: React.FC<Props> = ({ loading, width, children, align, ...rest }: Props) => {
    let alignSkeleton: 'left' | 'center' | 'right' | undefined
    if (align === 'left' || align === 'center' || align === 'right') {
        alignSkeleton = align
    }

    return (
        <GenericLoader loading={loading} skeletonProps={{ width, height: 19 }} alignSkeleton={alignSkeleton}>
            <BlockTypography {...rest} align={align} variant="body1">
                {children}
            </BlockTypography>
        </GenericLoader>
    )
}
